import React from 'react'
import type { FormikValues } from 'formik'
import { useField } from 'formik'

import { TtCheckbox } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtCheckboxFormik = <FV extends FormikValues>({
  name,
  validate,
  value,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-checkbox'> & {
  name: FieldNameMatchingAcceptedType<FV, boolean | undefined>
}) => {
  const [field, meta, helpers] = useField<boolean>({
    name,
    validate,
  })

  const checkedStatus = field.value ? 'true' : 'false'

  return (
    <TtCheckbox
      {...props}
      name={field.name}
      value={value}
      checked={checkedStatus}
      onBlur={field.onBlur}
      onTt-change={(e) => {
        helpers.setValue(e.detail.checked !== 'false')
      }}
      invalid={meta.touched && (!!meta.error || invalid)}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtCheckboxFormik }
